// svelte store for a the side bar state here, including hte functions


// store.js
import { writable } from 'svelte/store';

export const sidebarStore = writable(false);
